import { CASQuickLinks } from '../../../cimsPage/instances/cas'
import { QuickLinks } from '../../common'

const quickLinks = QuickLinks({
  page: CASQuickLinks,
  create: '00BE8FAB-0795-44AA-A82B-9FE39E5DC658',
  view: '5C198284-98E8-48D1-A2CE-06557E021C73',
  edit: 'D9066B29-88DF-46B6-B2E0-94F94759611C',
  removeRestore: '9C046853-D0F4-4C34-A1F1-8B315165527D',
})

export const CreateCASQuickLink = quickLinks.Create
export const ViewCASQuickLink = quickLinks.View
export const EditCASQuickLink = quickLinks.Edit
export const RemoveRestoreCASQuickLink = quickLinks.RemoveRestore

export type CASQuickLinkPermission =
  | typeof CreateCASQuickLink
  | typeof ViewCASQuickLink
  | typeof EditCASQuickLink
  | typeof RemoveRestoreCASQuickLink
